// src/pages/Gallery/Gallery.js
import React, { useState } from 'react';
import './Gallery.css';

import psClass     from '../../gallery/ps-class.JPG';
import psClass2    from '../../gallery/ps-class2.JPG';
import psAct       from '../../gallery/ps-activities.JPG';
import psAct2      from '../../gallery/ps-activities2.JPG';
import psEvents    from '../../gallery/ps-events.JPG';
import psEvents2   from '../../gallery/ps-events2.JPG';
import psFac       from '../../gallery/ps-facilities.JPG';
import psFac2      from '../../gallery/ps-facilities2.JPG';

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all',        name: 'All' },
    { id: 'classroom',  name: 'Classroom' },
    { id: 'activities', name: 'Activities' },
    { id: 'events',     name: 'Events' },
    { id: 'facilities', name: 'Facilities' }
  ];

  const galleryItems = [
    { id: 1, category: 'classroom',  title: 'Playgroup Classroom',    img: psClass },
    { id: 2, category: 'classroom',  title: 'Nursery Learning Area',  img: psClass2 },
    { id: 3, category: 'activities', title: 'Art & Craft Session',    img: psAct },
    { id: 4, category: 'activities', title: 'Music Time',             img: psAct2 },
    { id: 5, category: 'events',     title: 'Annual Day Celebration', img: psEvents },
    { id: 6, category: 'events',     title: 'Sports Day',             img: psEvents2 },
    { id: 7, category: 'facilities', title: 'Play Area',              img: psFac },
    { id: 8, category: 'facilities', title: 'Library Corner',         img: psFac2 },
  ];

  const filteredItems = selectedCategory === 'all'
    ? galleryItems
    : galleryItems.filter(item => item.category === selectedCategory);

  return (
    <div className="gallery-page page-content">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <h1 className="page-title">Our Gallery</h1>
          <p className="page-subtitle">Explore the vibrant moments of learning and fun at DisneyLand</p>
        </div>
      </section>

      {/* Gallery Content */}
      <section className="gallery-section">
        <div className="container">
          {/* Category Filter */}
          <div className="gallery-filters">
            {categories.map(category => (
              <button
                key={category.id}
                className={`filter-btn ${selectedCategory === category.id ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category.id)}
              >
                {category.name}
              </button>
            ))}
          </div>

          {/* Gallery Grid */}
          <div className="gallery-grid">
            {filteredItems.map(item => (
              <div key={item.id} className="gallery-item">
                <div className="gallery-img-wrapper">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="gallery-img"
                  />
                </div>
                <div className="gallery-info">
                  <h3>{item.title}</h3>
                  <span className="gallery-category">{item.category}</span>
                </div>
              </div>
            ))}
          </div>

          {filteredItems.length === 0 && (
            <div className="no-results">
              <p>No images found in this category.</p>
            </div>
          )}
        </div>
      </section>

      {/* Video Section */}
      <section className="video-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Virtual Tour</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">
              Take a virtual tour of our facilities and see where your child will learn and grow
            </p>
          </div>
          <div className="video-grid">
            <div className="video-card">
              <div className="video-placeholder">
                <div className="play-button">▶</div>
                <p>Campus Tour</p>
              </div>
              <h3>Explore Our Campus</h3>
            </div>
            <div className="video-card">
              <div className="video-placeholder">
                <div className="play-button">▶</div>
                <p>Daily Activities</p>
              </div>
              <h3>A Day at DisneyLand</h3>
            </div>
            <div className="video-card">
              <div className="video-placeholder">
                <div className="play-button">▶</div>
                <p>Parent Testimonials</p>
              </div>
              <h3>What Parents Say</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Parent Testimonials</h2>
            <div className="title-underline"></div>
          </div>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="quote-icon">"</div>
              <p className="testimonial-text">
                DisneyLand has been an amazing experience for our daughter. The teachers are caring
                and the curriculum is excellent. We've seen tremendous growth in her confidence and skills.
              </p>
              <div className="testimonial-author">
                <div className="author-avatar">👤</div>
                <div className="author-info">
                  <h4>Mrs. Sharma</h4>
                  <p>Parent of Aarav (Nursery)</p>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="quote-icon">"</div>
              <p className="testimonial-text">
                The safety measures and individual attention given to each child is commendable.
                My son looks forward to going to school every day!
              </p>
              <div className="testimonial-author">
                <div className="author-avatar">👤</div>
                <div className="author-info">
                  <h4>Mr. & Mrs. Patel</h4>
                  <p>Parents of Riya (Kindergarten)</p>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="quote-icon">"</div>
              <p className="testimonial-text">
                The holistic approach to education and the variety of activities have helped our child
                develop in all areas. Highly recommend DisneyLand!
              </p>
              <div className="testimonial-author">
                <div className="author-avatar">👤</div>
                <div className="author-info">
                  <h4>Mrs. Singh</h4>
                  <p>Parent of Arjun (Pre-Nursery)</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;










// // src/pages/Gallery/Gallery.js
// import React, { useState } from 'react';
// import './Gallery.css';

// const Gallery = () => {
//   const [selectedCategory, setSelectedCategory] = useState('all');

//   const categories = [
//     { id: 'all', name: 'All' },
//     { id: 'classroom', name: 'Classroom' },
//     { id: 'activities', name: 'Activities' },
//     { id: 'events', name: 'Events' },
//     { id: 'facilities', name: 'Facilities' }
//   ];

//   const galleryItems = [
//     { id: 1, category: 'classroom', title: 'Playgroup Classroom', icon: '🎨', color: '#FF6B9D' },
//     { id: 2, category: 'classroom', title: 'Nursery Learning Area', icon: '📚', color: '#4ECDC4' },
//     { id: 3, category: 'activities', title: 'Art & Craft Session', icon: '✂️', color: '#FFD93D' },
//     { id: 4, category: 'activities', title: 'Music Time', icon: '🎵', color: '#9B59B6' },
//     { id: 5, category: 'events', title: 'Annual Day Celebration', icon: '🎉', color: '#FF8C42' },
//     { id: 6, category: 'events', title: 'Sports Day', icon: '⚽', color: '#52C41A' },
//     { id: 7, category: 'facilities', title: 'Play Area', icon: '🎪', color: '#4A90E2' },
//     { id: 8, category: 'facilities', title: 'Library Corner', icon: '📖', color: '#E74C3C' },
//     { id: 9, category: 'classroom', title: 'Pre-Nursery Room', icon: '🖍️', color: '#FF6B9D' },
//     { id: 10, category: 'activities', title: 'Story Time', icon: '📚', color: '#4ECDC4' },
//     { id: 11, category: 'events', title: 'Festival Celebration', icon: '🎊', color: '#FFD93D' },
//     { id: 12, category: 'facilities', title: 'Outdoor Garden', icon: '🌳', color: '#9B59B6' },
//     { id: 13, category: 'classroom', title: 'Kindergarten Class', icon: '✏️', color: '#FF8C42' },
//     { id: 14, category: 'activities', title: 'Dance Session', icon: '💃', color: '#52C41A' },
//     { id: 15, category: 'events', title: 'Parent-Teacher Meet', icon: '👨‍👩‍👧', color: '#4A90E2' },
//   ];

//   const filteredItems = selectedCategory === 'all' 
//     ? galleryItems 
//     : galleryItems.filter(item => item.category === selectedCategory);

//   return (
//     <div className="gallery-page page-content">
//       {/* Page Header */}
//       <section className="page-header">
//         <div className="container">
//           <h1 className="page-title">Our Gallery</h1>
//           <p className="page-subtitle">Explore the vibrant moments of learning and fun at DisneyLand</p>
//         </div>
//       </section>

//       {/* Gallery Content */}
//       <section className="gallery-section">
//         <div className="container">
//           {/* Category Filter */}
//           <div className="gallery-filters">
//             {categories.map(category => (
//               <button
//                 key={category.id}
//                 className={`filter-btn ${selectedCategory === category.id ? 'active' : ''}`}
//                 onClick={() => setSelectedCategory(category.id)}
//               >
//                 {category.name}
//               </button>
//             ))}
//           </div>

//           {/* Gallery Grid */}
//           <div className="gallery-grid">
//             {filteredItems.map(item => (
//               <div 
//                 key={item.id} 
//                 className="gallery-item"
//                 style={{ '--item-color': item.color }}
//               >
//                 <div className="gallery-placeholder" style={{ backgroundColor: item.color }}>
//                   <span className="gallery-icon">{item.icon}</span>
//                 </div>
//                 <div className="gallery-info">
//                   <h3>{item.title}</h3>
//                   <span className="gallery-category">{item.category}</span>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {filteredItems.length === 0 && (
//             <div className="no-results">
//               <p>No images found in this category.</p>
//             </div>
//           )}
//         </div>
//       </section>

//       {/* Video Section */}
//       <section className="video-section">
//         <div className="container">
//           <div className="section-header">
//             <h2 className="section-title">Virtual Tour</h2>
//             <div className="title-underline"></div>
//             <p className="section-subtitle">
//               Take a virtual tour of our facilities and see where your child will learn and grow
//             </p>
//           </div>
//           <div className="video-grid">
//             <div className="video-card">
//               <div className="video-placeholder">
//                 <div className="play-button">▶</div>
//                 <p>Campus Tour</p>
//               </div>
//               <h3>Explore Our Campus</h3>
//             </div>
//             <div className="video-card">
//               <div className="video-placeholder">
//                 <div className="play-button">▶</div>
//                 <p>Daily Activities</p>
//               </div>
//               <h3>A Day at DisneyLand</h3>
//             </div>
//             <div className="video-card">
//               <div className="video-placeholder">
//                 <div className="play-button">▶</div>
//                 <p>Parent Testimonials</p>
//               </div>
//               <h3>What Parents Say</h3>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Testimonials */}
//       <section className="testimonials-section">
//         <div className="container">
//           <div className="section-header">
//             <h2 className="section-title">Parent Testimonials</h2>
//             <div className="title-underline"></div>
//           </div>
//           <div className="testimonials-grid">
//             <div className="testimonial-card">
//               <div className="quote-icon">"</div>
//               <p className="testimonial-text">
//                 DisneyLand has been an amazing experience for our daughter. The teachers are caring 
//                 and the curriculum is excellent. We've seen tremendous growth in her confidence and skills.
//               </p>
//               <div className="testimonial-author">
//                 <div className="author-avatar">👤</div>
//                 <div className="author-info">
//                   <h4>Mrs. Sharma</h4>
//                   <p>Parent of Aarav (Nursery)</p>
//                 </div>
//               </div>
//             </div>
//             <div className="testimonial-card">
//               <div className="quote-icon">"</div>
//               <p className="testimonial-text">
//                 The safety measures and individual attention given to each child is commendable. 
//                 My son looks forward to going to school every day!
//               </p>
//               <div className="testimonial-author">
//                 <div className="author-avatar">👤</div>
//                 <div className="author-info">
//                   <h4>Mr. & Mrs. Patel</h4>
//                   <p>Parents of Riya (Kindergarten)</p>
//                 </div>
//               </div>
//             </div>
//             <div className="testimonial-card">
//               <div className="quote-icon">"</div>
//               <p className="testimonial-text">
//                 The holistic approach to education and the variety of activities have helped our child 
//                 develop in all areas. Highly recommend DisneyLand!
//               </p>
//               <div className="testimonial-author">
//                 <div className="author-avatar">👤</div>
//                 <div className="author-info">
//                   <h4>Mrs. Singh</h4>
//                   <p>Parent of Arjun (Pre-Nursery)</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Gallery;